"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
// @ts-nocheck
var utils_1 = __importDefault(require("@blaze-react/utils"));
var isSoftNewlineEvent_1 = __importDefault(require("draft-js/lib/isSoftNewlineEvent"));
var draft_js_1 = require("draft-js");
var react_1 = __importStar(require("react"));
var constants_1 = require("./constants");
var DecoratedLink_1 = __importDefault(require("./DecoratedLink"));
var EditorViewLinkModal_1 = __importDefault(require("./EditorViewLinkModal"));
var InlineToolbar_1 = __importDefault(require("./InlineToolbar"));
var link_strategy_1 = __importDefault(require("./link-strategy"));
var text_block_parser_1 = __importDefault(require("./text-block-parser"));
exports.parseTextBlock = text_block_parser_1["default"];
var inline_toolbar_utils_1 = require("./inline-toolbar-utils");
var DraftEditor = function (_a) {
    var _b = _a.utils, buildClassNames = _b.buildClassNames, ErrorMessage = _b.ErrorMessage, onChange = _a.onChange, name = _a.name, value = _a.value, error = _a.error, validationMessage = _a.validationMessage, unSelectedText = _a.unSelectedText, handleLibraryClick = _a.handleLibraryClick, showTopBar = _a.showTopBar, attrs = __rest(_a, ["utils", "onChange", "name", "value", "error", "validationMessage", "unSelectedText", "handleLibraryClick", "showTopBar"]);
    var _c = react_1.useState(false), inlineToolbar = _c[0], showInlineToolbar = _c[1];
    var _d = react_1.useState(false), addLinkModal = _d[0], showAddLinkModal = _d[1];
    var _e = react_1.useState(null), linkContentState = _e[0], setLinkContentState = _e[1];
    var inputEl = react_1.useRef(null);
    var handleOnEditLink = function (_contentState, entityKey, children) {
        setLinkContentState({
            contentState: _contentState,
            entityKey: entityKey
        });
        showAddLinkModal(true);
    };
    var _f = react_1.useState(function () {
        var linkDecorator = new draft_js_1.CompositeDecorator([
            {
                strategy: link_strategy_1["default"],
                component: DecoratedLink_1["default"],
                props: {
                    editLinkFn: handleOnEditLink
                }
            },
        ]);
        if (value) {
            var newEditorState = draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(JSON.parse(value)));
            var newEditorStateWithDecorators = draft_js_1.EditorState.set(newEditorState, {
                decorator: linkDecorator
            });
            return newEditorStateWithDecorators;
        }
        return draft_js_1.EditorState.createEmpty(linkDecorator);
    }), editorState = _f[0], setEditorState = _f[1];
    var handleOnChange = function (state) {
        save(state);
    };
    var focusEditor = react_1["default"].useCallback(function () {
        if (inputEl.current) {
            inputEl.current.focus();
            showInlineToolbar(true);
        }
    }, []);
    react_1.useLayoutEffect(function () {
        focusEditor();
    }, [focusEditor]);
    var _g = react_1.useState({
        left: 0,
        width: 0,
        right: 0,
        top: 0,
        bottom: 0,
        height: 0
    }), selectionRect = _g[0], setSelectionRect = _g[1];
    react_1.useLayoutEffect(function () {
        if (draft_js_1.getVisibleSelectionRect(window) !== null) {
            setSelectionRect(draft_js_1.getVisibleSelectionRect(window));
        }
    }, [editorState, setSelectionRect]);
    var save = function (state, action) {
        var currentContent = editorState.getCurrentContent();
        var newContent = state.getCurrentContent();
        if (currentContent !== newContent ||
            action === "add-link" ||
            action === "update-link") {
            setLinkContentState(null);
            showInlineToolbar(false);
        }
        if (inlineToolbar) {
            showInlineToolbar(false);
        }
        setEditorState(state);
        showInlineToolbar(true);
    };
    var onEditorChange = function (newEditorState) {
        var currentContent = newEditorState.getCurrentContent();
        var rawValue = draft_js_1.convertToRaw(currentContent);
        var blocks = rawValue.blocks.map(function (block) {
            if (block.type === "atomic" && !!block.text.trim()) {
                block.text = block.text.replace(/\s+/g, " ");
            }
            return block;
        });
        rawValue.blocks = blocks;
        var rawValueString = JSON.stringify(__assign({}, rawValue));
        var eventFormat = {
            event: {
                target: {
                    name: name,
                    value: rawValueString
                }
            }
        };
        if (onChange) {
            setEditorState(newEditorState);
            onChange(eventFormat);
        }
    };
    var contentState = editorState.getCurrentContent();
    var getBlockStyle = function (block) {
        var isBlockquote = block.getType() === constants_1.BLOCKQUOTE;
        return buildClassNames({
            "custom-DraftEditor-blockquote": isBlockquote
        });
    };
    var handleKeyCommand = function (command) {
        if (command === constants_1.KEY_BINDING_UNDO) {
            var undoState = draft_js_1.EditorState.undo(editorState);
            save(undoState, UNDO);
            return constants_1.KEY_BINDING_NOT_HANDLED;
        }
        if (command === constants_1.KEY_BINDING_ADD_LINK) {
            showAddLinkModal(true);
            return constants_1.KEY_BINDING_HANDLED;
        }
        if (command === constants_1.KEY_BINDING_SAVE_ACTION) {
            save(editorState);
            return constants_1.KEY_BINDING_HANDLED;
        }
        if (command === constants_1.KEY_BINDING_TOOLBAR_ACTION) {
            showInlineToolbar(true);
            var currentContent = editorState.getCurrentContent();
            var selection = editorState.getSelection().merge({
                anchorKey: currentContent.getFirstBlock().getKey(),
                anchorOffset: 0,
                focusOffset: currentContent.getLastBlock().getText().length,
                focusKey: currentContent.getLastBlock().getKey()
            });
            setEditorState(draft_js_1.EditorState.forceSelection(editorState, selection));
        }
        var newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
        if (newState && command !== constants_1.BACKSPACE_COMMAND) {
            setEditorState(newState);
            save(newState, FORMAT);
            return constants_1.KEY_BINDING_HANDLED;
        }
        return constants_1.KEY_BINDING_NOT_HANDLED;
    };
    var handleAddLink = function (url, linkState) {
        if (url === "") {
            if (linkState) {
                var newEditorState = removeEntity(editorState);
                setEditorState(newEditorState);
                save(newEditorState, constants_1.ADD_LINK);
            }
            else {
                var selection = editorState.getSelection();
                if (!selection.isCollapsed()) {
                    var newEditorState = draft_js_1.RichUtils.toggleLink(editorState, selection, null);
                    setEditorState(newEditorState);
                    save(newEditorState, constants_1.ADD_LINK);
                }
            }
        }
        else {
            var contentState_1 = editorState.getCurrentContent();
            if (linkState) {
                var entityKey = linkState.entityKey;
                var contentStateWithLink = contentState_1.replaceEntityData(entityKey, {
                    url: url
                });
                var newEditorState = draft_js_1.EditorState.set(editorState, {
                    currentContent: contentStateWithLink
                });
                save(newEditorState, constants_1.ADD_LINK);
            }
            else {
                var contentStateWithEntity = contentState_1.createEntity(constants_1.LINK, constants_1.MUTABLE, {
                    url: url
                });
                var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
                var contentStateWithLink = draft_js_1.Modifier.applyEntity(contentStateWithEntity, editorState.getSelection(), entityKey);
                var newEditorState = draft_js_1.EditorState.set(editorState, {
                    currentContent: contentStateWithLink
                });
                save(newEditorState, constants_1.ADD_LINK);
            }
        }
        showAddLinkModal(false);
    };
    var handleReturn = function (event) {
        if (isSoftNewlineEvent_1["default"](event)) {
            onEditorChange(draft_js_1.RichUtils.insertSoftNewline(editorState));
            return constants_1.HANDLED;
        }
        return constants_1.NOT_HANDLED;
    };
    var myKeyBindingFn = function (e) {
        if (e.keyCode === 90 && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            return constants_1.KEY_BINDING_UNDO;
        }
        if (e.keyCode === 83 && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            return constants_1.KEY_BINDING_SAVE_ACTION;
        }
        if (e.keyCode === 65 && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            return constants_1.KEY_BINDING_TOOLBAR_ACTION;
        }
        if (e.keyCode === 75 && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            return constants_1.KEY_BINDING_ADD_LINK;
        }
        return draft_js_1.getDefaultKeyBinding(e);
    };
    var blockRenderer = function (contentBlock) {
        var type = contentBlock.getType();
        if (type !== constants_1.ATOMIC) {
            return null;
        }
        var entityKey = contentBlock.getEntityAt(0);
        if (!entityKey) {
            return {
                editable: false
            };
        }
        var entity = contentState.getEntity(entityKey);
        if (entity && entity.type === constants_1.HORIZONTAL_RULE) {
            return {
                component: function () { return react_1["default"].createElement("hr", null); },
                editable: false
            };
        }
        return "";
    };
    var getSelectedText = function () {
        var selectionState = editorState.getSelection();
        var anchorKey = selectionState.getAnchorKey();
        var currentContent = editorState.getCurrentContent();
        var currentContentBlock = currentContent.getBlockForKey(anchorKey);
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();
        return currentContentBlock.getText().slice(start, end);
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { className: "custom-DraftEditor-root editor-view__textblock", onClick: function (e) {
                e.stopPropagation();
                focusEditor;
            } },
            react_1["default"].createElement("div", { className: "editor-view__textblock--editor", ref: function (el) {
                    if (!el)
                        return;
                    inline_toolbar_utils_1.Rect.rect = el.getBoundingClientRect();
                } },
                react_1["default"].createElement(InlineToolbar_1["default"], { editorState: editorState, setEditorState: setEditorState, selectionRect: selectionRect, showAddLinkModal: showAddLinkModal, onChange: function (state) { return handleOnChange(state); }, visible: inlineToolbar && getSelectedText() !== "" }),
                react_1["default"].createElement(draft_js_1.Editor, __assign({ ref: inputEl, handleKeyCommand: handleKeyCommand, blockStyleFn: getBlockStyle, editorState: editorState, onChange: onEditorChange, blockRendererFn: blockRenderer, handleReturn: handleReturn, keyBindingFn: myKeyBindingFn }, attrs)))),
        addLinkModal && (react_1["default"].createElement(EditorViewLinkModal_1["default"], { editorState: editorState, onClose: function () {
                showAddLinkModal(false);
                setLinkContentState(undefined);
            }, onSave: function (url, linkState) {
                handleAddLink(url, linkState);
                setLinkContentState(undefined);
            }, linkContentState: linkContentState })),
        error && react_1["default"].createElement(ErrorMessage, { message: validationMessage })));
};
DraftEditor.defaultProps = {
    error: false,
    name: "editor",
    unSelectedText: "Make sure you have a text selected",
    validationMessage: "This field is required"
};
exports["default"] = utils_1["default"](DraftEditor);
